import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import React, { useEffect, useRef } from 'react'
import moment from 'moment'

import { Day } from './components/ScheduleDay.js'
import { EventType } from './types'
import { EventCell } from './components/ScheduleEventCell.js'
import { useMedia } from './hooks/useMedia.js'
import { ScrollOverflowFadeWrapper } from './components/FadeOverlay.js'

export const EventsSchedule = ({ days = [], events = [] }) => {
  const isMobile = useMedia('(max-width: 639px)')
  const dayWidth = isMobile ? 80 : 100
  const rowHeight = isMobile ? 74 : 64

  const scheduleEventsRef = useRef()
  const scheduleDatesRef = useRef()

  useEffect(() => {
    if (scheduleEventsRef.current) {
      const handleScroll = () => {
        if (!scheduleDatesRef.current) return
        const scrollLeft = scheduleEventsRef.current.scrollLeft
        scheduleDatesRef.current.style.transform = `translateX(-${scrollLeft}px)`
      }
      scheduleEventsRef.current.addEventListener('scroll', handleScroll)
      return () => {
        if (scheduleEventsRef.current) scheduleEventsRef.current.removeEventListener('scroll', handleScroll)
      }
    }
  }, [scheduleEventsRef.current])

  useEffect(() => {
    let tracking = false
    let initialScroll = scheduleEventsRef.current ? scheduleEventsRef.current.scrollLeft : 0
    let initialPosX = 0
    let currentPosX = 0
    const handlePointerDown = e => {
      if (e.touches) e.preventDefault()
      tracking = true
      initialScroll = scheduleEventsRef.current.scrollLeft
      initialPosX = e.touches ? e.touches[0].clientX : e.clientX
      document.body.classList.add('cursor-grabbing')
      currentPosX = initialPosX
    }
    const handlePointerMove = e => {
      if (!tracking) return
      e.preventDefault()
      currentPosX = e.touches ? e.touches[0].clientX : e.clientX
      scheduleEventsRef.current.scrollLeft = Math.max(0, initialScroll + (initialPosX - currentPosX))
    }
    const handlePointerUp = () => {
      tracking = false
      document.body.classList.remove('cursor-grabbing')
    }
    window.addEventListener('touchmove', handlePointerMove)
    window.addEventListener('mousemove', handlePointerMove)
    window.addEventListener('mouseup', handlePointerUp)
    window.addEventListener('touchend', handlePointerUp)
    if (scheduleDatesRef.current && scheduleEventsRef.current) {
      scheduleDatesRef.current.addEventListener('touchstart', handlePointerDown)
      scheduleDatesRef.current.addEventListener('mousedown', handlePointerDown)
      scheduleEventsRef.current.addEventListener('mousedown', handlePointerDown)
    }
    return () => {
      if (!scheduleDatesRef.current || !scheduleEventsRef.current) return
      scheduleDatesRef.current.removeEventListener('touchstart', handlePointerDown)
      scheduleDatesRef.current.removeEventListener('mousedown', handlePointerDown)
      scheduleEventsRef.current.removeEventListener('mousedown', handlePointerDown)
    }
  }, [scheduleDatesRef.current, scheduleEventsRef.current])

  return (
    <div className="schedule-wrap">
      <header className="schedule-header">
        <div className="schedule-header-left">Show</div>
        <div className="schedule-header-right">
          <div className="header-days">
            <div className="header-days-inner cursor-grab user-select-none touch-action-none" ref={scheduleDatesRef}>
              {days.map(day => {
                return (
                  <div key={day} className="header-day" style={{ width: dayWidth, flex: '0 0 ' + dayWidth + 'px' }}>
                    {moment(day).format('ddd D MMM')}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </header>
      <main className="schedule-main">
        <aside className="schedule-sidebar">
          <ul className="schedule-sidebar-events">
            {events.map(event => (
              <EventCell key={event.id} event={event} rowHeight={rowHeight} />
            ))}
          </ul>
        </aside>
        <div className="schedule-events">
          <div className="schedule-events-inner user-select-none" ref={scheduleEventsRef}>
            <div className="schedule-days">
              {days.map((day, i) => {
                return (
                  <div className="schedule-day" key={`schedule-day-${day}`} style={{ flex: '0 0 ' + dayWidth + 'px' }}>
                    <Day key={`day-${i}`} dayWidth={dayWidth} rowHeight={rowHeight} day={day} events={events} />
                  </div>
                )
              })}
            </div>
          </div>
          <ScrollOverflowFadeWrapper placement="horizontal" ref={scheduleEventsRef} />
        </div>
      </main>
    </div>
  )
}
EventsSchedule.propTypes = {
  events: PropTypes.arrayOf(EventType).isRequired,
  days: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default EventsSchedule

window.EventsSchedule = {
  init: (id, props) => {
    console.log('window.EventsSchedule called')
    ReactDOM.render(<EventsSchedule {...props} />, document.getElementById(id))
  },
}
